import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaUser, FaSignOutAlt, FaChevronDown, FaCog } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';

const UserProfile = ({ compact = false }) => {
  const { user, logout } = useAuth();
  const { t } = useTranslation();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  if (!user) return null;

  const handleLinkClick = () => {
    setIsDropdownOpen(false);
  };

  return (
    <div className={`user-profile ${compact ? 'user-profile-compact' : ''}`}>
      <button
        type="button"
        className="user-info"
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        aria-label={compact ? t('userDropdown.profile') : undefined}
        aria-haspopup="menu"
        aria-expanded={isDropdownOpen}
        title={compact ? t('userDropdown.profile') : undefined}
      >
        {user.avatar ? (
          <img src={user.avatar} alt="User Avatar" className="user-avatar" />
        ) : (
          <div className="user-avatar-placeholder">
            <FaUser />
          </div>
        )}
        {!compact && (
          <>
            <span className="user-name">{user.name}</span>
            <FaChevronDown className={`dropdown-arrow ${isDropdownOpen ? 'open' : ''}`} />
          </>
        )}
      </button>

      {isDropdownOpen && (
        <div className="user-dropdown">
          <div className="dropdown-item user-details">
            <p><strong>{user.name}</strong></p>
            <p className="user-email">{user.email}</p>
          </div>
          <hr />
          <Link 
            to="/profile" 
            className="dropdown-item profile-link" 
            onClick={handleLinkClick}
          >
            <FaCog />
            {t('userDropdown.profile')}
          </Link>
          <hr />
          <button className="dropdown-item logout-button" onClick={logout}>
            <FaSignOutAlt />
            {t('userDropdown.signOut')}
          </button>
        </div>
      )}
    </div>
  );
};

export default UserProfile;
